<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>
            TITLE.TITLE_STAFF_DEVICE
        </h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>
        <div class="row ml-3">
            <div class="col pl-0">
                <label for="DeviceType" class="col-form-label" translate>LBL.DEVICE_TYPE</label>
                <select class="custom-select" [(ngModel)]="Model.DeviceType" name="DeviceType" id="DeviceType" (change)="SetField()" [disabled]="Model.DeviceId || IsDeviceEdited">
                    <option [value]="0" disabled>Select Device Type</option>
                    <option *ngFor="let row of DeviceList" [ngValue]="row.Id">{{row.Name}}</option>
                </select>
            </div>
        </div>
        <div class="row ml-3">
            <div class="col form-group pl-0">
                <label for="DeviceNumber" class="col-form-label" translate>LBL.DEVICE_NUMBER</label>
                <input type="text" class="form-control" [(ngModel)]="Model.DeviceNumber" id="DeviceNumber" placeholder="{{'PH.PH_DEVICE_NUMBER' | translate}}" [disabled]="Model.DeviceType == 1 || Model.DeviceType == 6">
            </div>
        </div>
        <div class="row ml-3" *ngIf="Model.DeviceAllocationType != 2">
            <div class="col form-check">
                <input class="form-check-input" type="checkbox" id="IsEnabled" [(ngModel)]="Model.IsEnabled">
                <label class="form-check-label" for="IsEnabled" translate>
                    LBL.IS_ENABLED
                </label>
            </div>
        </div>

    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="DisableModalOpenEvent = false;SaveMapping()" translate>BTN.BTN_OK</button>
        <!--<button type="button" class="btn" (click)="d('dismiss')"><span translate>TWTSS.BTN_CANCEL</span></button>-->
    </div>

</ng-template>
